export default function precisionRound(num, precision, type = 'round') {
  const factor = 10 ** precision;
  if (type === 'round') {
    return Math.round((num + Number.EPSILON) * factor) / factor;
  }
  if (type === 'ceil') {
    return Math.ceil((num + Number.EPSILON) * factor) / factor;
  }
  if (type === 'floor') {
    return Math.floor((num + Number.EPSILON) * factor) / factor;
  }
  return num;
}
